import { REASSIGN_CONNECTIONS_MODAL as FEATURE_PREFIX } from 'featurePrefix.ids'

const ids = {
  ActionReassign: `${FEATURE_PREFIX}__reassign`,
  ActionRemove: `${FEATURE_PREFIX}__remove`,
  CancelButton: `${FEATURE_PREFIX}__cancel-button`,
  CloseButton: `${FEATURE_PREFIX}__close-button`,
  ConfirmReassignButton: `${FEATURE_PREFIX}__confirm-reassign-to-another-sales-rep`,
  ConfirmRemoveButton: `${FEATURE_PREFIX}__confirm-remove-all-connections`,
  SourceUserDropdown: `${FEATURE_PREFIX}__source-user-dropdown`,
  TargetUserDropdown: `${FEATURE_PREFIX}__target-user-dropdown`,
  Title: `${FEATURE_PREFIX}__title`,
  Warning: `${FEATURE_PREFIX}__warning`,
} as const

export default ids
